/**
 * ModulePageHeader - Standard header for alle module pages
 * Inkluderer tilbake-knapp, tittel, badge og lovhenvisning
 * @version 2.0.0 - MASTERPROMPT v2.0 compliant
 */
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, Sparkles, Shield } from 'lucide-react';
import { useMemo } from 'react';

export function ModulePageHeader({ 
  title, 
  badge = 'Master',
  badgeIcon = 'sparkles', // 'sparkles' | 'shield'
  lawReference,
  backRoute = '/chat'
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const BadgeIcon = badgeIcon === 'shield' ? Shield : Sparkles;
  
  // Sjekk om vi er i B2B-kontekst
  const isCompanyContext = useMemo(() => {
    const fromState = location.state?.fromCompany;
    const isCompanyPath = location.pathname.startsWith('/company/');
    return fromState || isCompanyPath || sessionStorage.getItem('rettwerk_company_context') === 'true';
  }, [location.pathname, location.state]);
  
  // Dynamisk tilbake-rute basert på kontekst
  const dynamicBackRoute = isCompanyContext ? '/company/dashboard' : backRoute;
  
  return (
    <div className="flex items-center gap-4 mb-6">
      <button
        onClick={() => navigate(dynamicBackRoute)}
        className="p-2 rounded-lg bg-[var(--bg-surface)] border border-[var(--border-subtle)] text-[var(--text-muted)] hover:text-[var(--text-main)] hover:border-[var(--copper)]/50 transition-all"
        data-testid={`${title.toLowerCase()}-back-btn`}
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-bold text-[var(--text-main)]">{title}</h1>
          {badge && (
            <span className="px-2 py-0.5 text-[10px] font-bold bg-[var(--copper)]/20 text-[var(--copper)] rounded flex items-center gap-1">
              <BadgeIcon className="w-3 h-3" />
              {badge}
            </span>
          )}
        </div>
        {lawReference && (
          <p className="text-xs text-[var(--text-muted)]">{lawReference}</p>
        )}
      </div>
    </div>
  );
}

export default ModulePageHeader;
